import { Link, useNavigate } from "react-router-dom";
import backBtn from "../../assets/icons/back-btn.png";
import logo from "../../assets/doctio-logo.svg";
import fraseIkon from "../../assets/icons/Paper-icon + circle.svg";
import medicinstuderende from "../../assets/people/medicinstuderende.png";
import mail from "../../assets/icons/mail.svg";
import { StatsData } from "../../types/Signup/SignUpStep";
import Stats from "../Stats/Stats";

export default function ActivationStep({
  nextStep,
  statsData,
}: {
  nextStep: any;
  statsData: StatsData;
}) {
  const navigate = useNavigate();

  return (
    <div>
      <section className="md:h-screen">
        <div className="grid mx-auto h-full md:grid-cols-2">
          <div className="bg-white container md:w-2/4 mx-auto w-full md:py-6  order-2 md:order-1">
            <div className="header mt-2 hidden md:block flex items-center justify-between md:block">
              <button
                className="flex items-center md:mb-24"
                onClick={() => navigate(-1)}
              >
                <img src={backBtn} width={26} className="mr-3" alt="Tilbage" />
                <p className="text-doctio-green">Tilbage</p>
              </button>
              <img
                src={logo}
                width={150}
                className="md:mr-3 md:mb-20"
                alt="Logo"
              />
            </div>

            <h1 className="font-bold leading-tight tracking-tight text-doctio-green text-d2xl">
              Din mail er bekræftet
            </h1>

            <p>
              Din mail er nu bekræftet. Klik på næste for at vælge abonnoment og
              afslutte din oprettelse.
            </p>

            <button
              type="button"
              onClick={nextStep}
              className={`text-white transition-colors mt-10 mb-20 md:mb-36 w-full duration-300 ease-in-out font-bold rounded-full bg-doctio-green hover:bg-white hover:text-doctio-green hover:shadow-md"
                } focus:ring-4 focus:outline-none px-4 py-4 text-center mr-3 md:mr-0`}
            >
              Næste
            </button>

            <img
              src={mail}
              width={300}
              className="mx-auto w-7/12 md:w-[300px] md:mx-auto"
              alt="Sendt email"
            />
          </div>

          <div className="relative mx-auto w-full container md:max-w-none md:bg-doctio-lightgreen md:py-40 md:h-screen order-1 md:order-2 overflow-hidden">
            <div className="shadow-right"></div>
            <div className="md:w-2/3 mx-auto">
              <div className="image-container relative">
                <div className="header mt-6 mb-6 md:hidden flex items-center justify-between md:block">
                  <Link to="/">
                    <img
                      src={logo}
                      width={150}
                      className="md:mr-3 md:mb-20 w-[120px] md:w-[150px]"
                      alt="Logo"
                    />
                  </Link>
                  <button
                    className="flex items-center md:mb-8"
                    onClick={() => navigate(-1)}
                  >
                    <img
                      src={backBtn}
                      width={26}
                      className="mr-3"
                      alt="Tilbage"
                    />
                    <p className="text-doctio-green">Tilbage</p>
                  </button>
                </div>
                <img
                  src={medicinstuderende}
                  className="mr-3 h-96 object-cover md:h-auto w-full md:object-fit picture-shadow mb-10 md:mb-0 shadow rounded-3xl"
                  alt="Medicinstuderende"
                />

                <div className="mt-12 mb-10 hidden md:block">
                  <p className="leading-tight tracking-tight">
                    <span className="font-bold">Navn Navnesen</span>, Titel lige
                    her, Hospitalsnavn.
                  </p>
                  <p className="mt-2 italic">Bruger af Doctio</p>
                </div>

                <div className="absolute hidden md:block frase-ikon-sign left-[-95px] top-[40%]">
                  <img
                    src={fraseIkon}
                    width={199}
                    className="mr-3"
                    alt="Tilbage"
                  />
                </div>
              </div>
              <Stats data={statsData} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
